import { render, staticRenderFns } from "./probubbles.vue?vue&type=template&id=fe0ce7ee&"
import script from "./probubbles.vue?vue&type=script&lang=js&"
export * from "./probubbles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports